/*
 * VIZZYO — buton de inchidere pentru bara de anunt.
 *
 * Update-safe: fisier propriu, incarcat din snippets/vzy-update-safe-layer.liquid.
 * Nu atinge sections/announcement-bar.liquid, care e fisier al temei Digital.
 *
 * Inchiderea tine 24 de ore si doar pentru mesajul inchis: localStorage pastreaza
 * semnatura textului si momentul expirarii. Scriptul inline din snippet pune clasa
 * vzy-ann-dismissed pe <html> inainte de randare, ca bara sa nu apara si apoi sa
 * dispara; aici se confirma ca mesajul e acelasi, altfel bara revine.
 */
(() => {
  const KEY = 'vzy-announcement-dismissed';
  const HIDDEN_CLASS = 'vzy-ann-dismissed';
  const DAY_MS = 24 * 60 * 60 * 1000;
  const SELECTOR = '[id*="announcement-bar"] .announcement-bar__message';
  const root = document.documentElement;

  const hashOf = (text) => {
    let h = 0;
    for (let i = 0; i < text.length; i += 1) {
      h = ((h << 5) - h + text.charCodeAt(i)) | 0;
    }
    return String(h);
  };

  /* Valorile vechi (doar semnatura, fara expirare) nu mai sunt valide. */
  const readStore = () => {
    try {
      const saved = JSON.parse(window.localStorage.getItem(KEY));
      return saved && saved.until > Date.now() ? saved : null;
    } catch (error) {
      return null;
    }
  };

  const writeStore = (signature) => {
    try {
      window.localStorage.setItem(KEY, JSON.stringify({ signature, until: Date.now() + DAY_MS }));
    } catch (error) {
      /* private mode: bara reapare la reincarcare, acceptabil */
    }
  };

  const clearStore = () => {
    try {
      window.localStorage.removeItem(KEY);
    } catch (error) {
      /* nimic de sters */
    }
  };

  const init = () => {
    const bar = document.querySelector(SELECTOR);
    if (!bar || bar.dataset.vzyDismissReady === 'true') return;

    const signature = hashOf((bar.textContent || '').replace(/\s+/g, ' ').trim());
    bar.dataset.vzyDismissReady = 'true';

    const saved = readStore();
    const designMode = Boolean(window.Shopify && window.Shopify.designMode);
    if (saved && saved.signature === signature && !designMode) {
      root.classList.add(HIDDEN_CLASS);
      return;
    }

    /* Expirat, mesaj nou sau editorul de teme: bara ramane vizibila. */
    root.classList.remove(HIDDEN_CLASS);
    if (!designMode) clearStore();

    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'vzy-announcement-dismiss';
    button.setAttribute('aria-label', 'Închide anunțul');
    button.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="m7 7 10 10M17 7 7 17"/></svg>';
    button.addEventListener('click', () => {
      root.classList.add(HIDDEN_CLASS);
      writeStore(signature);
    });

    bar.appendChild(button);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
